// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2332":"ccbcf5b4","3583":"e2977132","3775":"6dfe949b","3783":"2e7fbb84","3964":"6dfe949b","4075":"6dfe949b","4395":"6dfe949b","4542":"6dfe949b","4821":"2e7fbb84","7248":"e2977132"}[chunkId] + ".chunk.css";
};